import patient from '@/sui/data/sheets/edit/patient'
import tools from '@/sui/data/sheets/edit/tools'
import ice from '@/sui/tools/ice'
import fields from '@/sui/data/sheets/edit/fields'
import assert from '@/sui/tools/assert'
import go from '@/gojs/go'
import clone from 'clone'

import {
  checkAge,
  checkDate,
  checkB2Gloves,
  checkDeviceInsertionSite,
  checkProbeTouchedWithGloves,
  checkBMI,
  checkP1Chlorex,
  checkNeedleWithdrawalManipType,
  checkEhpadService,
  checkIsolatedRinsingOfContinuousCatheter,
  checkGelAppliedWithoutSheath,
  checkVialOpenedSince,
  checkHeadFaceSterileField,
  checkGelUsed,
  checkRinsingSuccessivePushesCount,
  checkP5IsAdult,
  checkInjectedRinsingVolume,
  checkAntiseptic,
  checkFreeFlowWithDiscontinuousUsage
} from '@/sui/data/sheets/edit/notes/observa4'
import v2025 from '@/sui/data/sheets/edit/observa4/2025'
const result = clone(v2025)

//     UPDATE    obsManagment (list)    obsManagment>config>values: different sizes
result.fields.obsManagment.all.config.values = go.fields.obsManagment

// +++ ADD       fistula (list)
result.fields.fistula = {
  p5: tools.cfg.list(
    fields.fistula, `Voie d'abord`, go.fields.fistula, {
      sel: result.select.p5
    }
  )
}

// +++ ADD       buttonHole (list)
result.fields.buttonHole = {
  p5: tools.cfg.list(
    fields.buttonHole, `Button Hole ?`, go.fields.yesNo, {
      sel: tools.equals(result.fields.fistula.p5.field, 1)
    }
  )
}

// +++ ADD       p5type (list)
result.fields.catheterType.p5 = tools.cfg.list(
  `p5${fields.catheterType}`, result.fields.catheterType.p1.config.title,
  go.fields.p5Type, { sel: result.select.p5, srv: fields.catheterType }
)

//     UPDATE    deviceUsage (list)     deviceUsage>selectList>0/0: different function names "oneTrue (allTrue ((obsManagment === 4), (b1type in [7, 8, 9])), (obsManagment === 5))" "oneTrue ((obsManagment === 4), (obsManagment === 5))}"
result.fields.deviceUsage.b1b2 = tools.select(
  result.fields.deviceUsage.b1b2, result.select.b1b2
)

// +++ ADD       withHelp (list)
result.fields.withHelp = {
  b2: tools.cfg.list(
    fields.withHelp, `Présence d'une aide ?`, go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.b2, patient.select.isNeoOrDia
      )
    }
  )
}

// +++ ADD       injectedProduct (list)
result.fields.injectedProduct = {
  b1b2: tools.cfg.list(
    fields.injectedProduct, 'Produit perfusé', go.fields.injectedProduct, {
      sel: tools.oneTrue(
        tools.allTrue(
          result.select.b1,
          tools.inList(result.fields.manipType.b1.field, [1, 2, 3])
        ),
        tools.allTrue(
          result.select.b2,
          tools.inList(result.fields.manipType.b2.field, [1, 2, 3])
        )
      )
    }
  )
}

// +++ ADD       injectedProductDetail (text)
result.fields.injectedProductDetail = {
  b1b2: tools.cfg.text(
    fields.injectedProductDetail, 'Autre produit perfusé', {
      sel: tools.equals(result.fields.injectedProduct.b1b2.field, 4)
    }
  )
}

// +++ ADD       p5audited (list)
result.fields.audited.p5 = tools.cfg.list(
  `p5${fields.audited}`, result.fields.audited.p1.config.title, go.fields.p5Audited,
  { sel: result.select.p5, srv: fields.audited }
)

//     UPDATE    auditedCleanOutfit (list)auditedCleanOutfit>selectList>0/0: different function names "oneTrue ((obsManagment === 2), (obsManagment === 3), (obsManagment === 6), (obsManagment === 4), (obsManagment === 5))" "oneTrue ((obsManagment === 2), (obsManagment === 3), (obsManagment === 6), (obsManagment === 8), (obsManagment === 4), (obsManagment === 5))}"
result.fields.auditedCleanOutfit = {
  p2p3p4p5b1b2: tools.select(
    result.fields.auditedCleanOutfit.p2p3p4b1b2,
    result.select.p2p3p4p5b1b2
  )
}

// +++ ADD       auditedOvercoat (list)
result.fields.auditedOvercoat = {
  p5: tools.cfg.list(
    fields.auditedOvercoat,
    `Port d'un tablier ou surblouse à usage unique dédié(e) au soin du patient`,
    go.fields.yesNo, { sel: result.select.p5 }
  )
}

//     UPDATE    auditedMask (list)     auditedMask>selectList>0/0: different function names "oneTrue ((obsManagment === 1), (obsManagment === 3), (obsManagment === 5), (obsManagment === 7))" "oneTrue ((obsManagment === 1), (obsManagment === 3), (obsManagment === 8), (obsManagment === 5), (obsManagment === 7))}"
result.fields.auditedMask = {
  p1p3p5b2r1: tools.select(
    result.fields.auditedMask.p1p3b2r1,
    result.select.p1p3p5b2r1
  )
}

result.rename(result.fields.compliantAuditedMask, 'p1p3b2r1', 'p1p3p5b2')

//     UPDATE    b2auditedCap (list)    b2auditedCap>selectList>0/0: different function names "allTrue ((obsManagment === 5), oneTrue ((unitTypeMatch /^NEO/), (unitTypeMatch /^AD DIA/)))" "allTrue ((obsManagment === 5), (unitTypeMatch /^NEO|DIA/))}"
result.fields.auditedCap.b2 = tools.select(
  result.fields.auditedCap.b2,
  tools.allTrue(result.select.b2, patient.select.isNeoOrDia)
)

// +++ ADD       auditedEyeProtection (list)
result.fields.auditedEyeProtection = {
  p5: tools.cfg.list(
    fields.auditedEyeProtection, `Port de protections oculaires`,
    go.fields.yesNo, { sel: result.select.p5 }
  )
}

//     UPDATE    patientCleanOutfit (list)patientCleanOutfit>selectList>0/0: different function names "oneTrue ((obsManagment === 1), (obsManagment === 2), (obsManagment === 3), (obsManagment === 6), (obsManagment === 5))" "oneTrue ((obsManagment === 1), (obsManagment === 2), (obsManagment === 3), (obsManagment === 6), (obsManagment === 8), (obsManagment === 5))}"
result.fields.patientCleanOutfit = {
  p1p2p3p4p5b2: tools.select(
    result.fields.patientCleanOutfit.p1p2p3p4b2,
    result.select.p1p2p3p4p5b2
  )
}

// +++ ADD       ultrasoundWipingBeforeCare (list)
// +++ ADD       ultrasoundWipingBeforeCareProduct (list)
// +++ ADD       ultrasoundWipingBeforeCareProductDetail (text)
result.fields.ultrasoundWipingBeforeCare = {
  p1p2: result.build.ultrasoundWiping(
    'BeforeCare', `avant de débuter le soin ?`,
    result.select.yes(result.fields.withUltrasound.p1p2.field)
  )
}

// --- REMOVE    ultrasoundWipingSearch (list)
// --- REMOVE    ultrasoundWipingSearchProduct (list)
// --- REMOVE    ultrasoundWipingSearchProductDetail (text)
delete result.fields.ultrasoundWipingSearch

//     UPDATE    handHygieneBeforeB1Disinfection (list)handHygieneBeforeB1Disinfection>config>title: different values (Hygiène des mains faite avant la désinfection de la connectique / Hygiène des mains faite juste avant le soin)
result.fields.handHygieneBeforeDisinfection.b1[0].config.title =
  `Hygiène des mains faite juste avant le soin`

// +++ ADD       insertionSiteCleanedByPatient (list)
result.fields.insertionSiteCleanedByPatient = {
  p5: tools.cfg.list(
    fields.insertionSiteCleanedByPatient,
    `Le patient a-t-il réalisé un nettoyage de la zone d'insertion ?`,
    go.fields.yesNo, { sel: result.select.p5 }
  )
}

// +++ ADD       p5insertionSiteCleaned (list)
result.fields.insertionSiteCleaned.p5 = tools.cfg.list(
  `p5${fields.insertionSiteCleaned}`,
  `Nettoyage de la zone d'insertion par le professionnel`,
  go.fields.yesNo, {
    sel: tools.allTrue(
      result.select.p5,
      result.select.no(result.fields.insertionSiteCleanedByPatient.p5.field)
    ),
    srv: fields.insertionSiteCleaned
  }
)

// +++ ADD       p5soap (list)
result.fields.soap.p5 = tools.cfg.list(
  `p5${fields.soap}`, result.fields.soap.p1p2p3p4r1.config.title, go.fields.p5Soap, {
    sel: tools.allTrue(
      result.select.p5,
      result.select.yes(result.fields.insertionSiteCleaned.p5.field)
    ),
    srv: fields.soap
  }
)

// +++ ADD       p5soapOther (text)
result.fields.soapOther.p5 = tools.cfg.text(
  `p5${fields.soapOther}`, result.fields.soapOther.p1p2p3p4r1.config.title,
  { sel: tools.equals(result.fields.soap.p5.field, 4), srv: fields.soapOther }
)

//     UPDATE    rincing (list)         rincing>selectList>0/0: different function names "allTrue ((obsManagment === 7), (insertionSiteCleaned === 1))" "allTrue (oneTrue ((obsManagment === 1), (obsManagment === 2), (obsManagment === 3), (obsManagment === 7)), (insertionSiteCleaned === 1))}"
result.fields.rinsing = {
  p1p2p3r1: tools.select(
    result.fields.rinsing.r1,
    tools.allTrue(
      result.select.p1p2p3r1,
      result.select.yes(result.fields.insertionSiteCleaned.p1p2p3p4r1.field)
    )
  )
}

//     UPDATE    dryingWithSterileCompresses (list)dryingWithSterileCompresses>selectList>0/0: different function names "allTrue ((obsManagment === 7), (insertionSiteCleaned === 1))" "allTrue (oneTrue ((obsManagment === 1), (obsManagment === 2), (obsManagment === 3), (obsManagment === 7)), (insertionSiteCleaned === 1))}"
result.fields.dryingWithSterileCompresses = {
  p1p2p3r1: tools.select(
    result.fields.dryingWithSterileCompresses.r1,
    tools.allTrue(
      result.select.p1p2p3r1,
      result.select.yes(result.fields.insertionSiteCleaned.p1p2p3p4r1.field)
    )
  )
}

// +++ ADD       rinsingProduct (list)
result.fields.rinsingProduct = {
  p5: tools.cfg.list(
    fields.rinsingProduct, `Rinçage avec`, go.fields.rinsingProduct,
    { sel: result.select.yes(result.fields.insertionSiteCleaned.p5.field) }
  )
}

// +++ ADD       dryingEquipment (list)
result.fields.dryingEquipment = {
  p5: tools.cfg.list(
    fields.dryingEquipment, `Séchage avec`, go.fields.dryingEquipment,
    { sel: result.select.yes(result.fields.insertionSiteCleaned.p5.field) }
  )
}

//     UPDATE    r1AntisepticApplied (list)r1AntisepticApplied>config>title: different values (Antisepsie du point de ponction / Antisepsie de la zone d'insertion)
result.fields.antiseptic.r1[0].config.title = `Antisepsie de la zone d'insertion`

// +++ ADD       p5AntisepticApplied (list)
// +++ ADD       p5Antiseptic (list)
// +++ ADD       p5AntisepticOther (text)
result.fields.antiseptic.p5 = result.build.antiseptic(
  'Antiseptic', `Antisepsie appliqué au niveau de la zone d'insertion ?`,
  `p5`, result.select.p5, go.fields.antiseptic
)

// +++ ADD       p5UseCompresses (list)
result.fields.useCompresses.p5 = tools.cfg.list(
  `p5UseCompresses`, `Utilisation de compresses pour l'antisepsie`,
  go.fields.yesNo, {
    sel: tools.allTrue(
      result.select.yes(result.fields.antiseptic.p5[0].field),
      tools.different(result.fields.antiseptic.p5[1].field, 7)
    ),
    srv: fields.useCompresses
  }
)

// +++ ADD       p5CompressesType (list)
result.fields.compressesType.p5 = tools.cfg.list(
  `p5CompressesType`, result.fields.compressesType.r1.config.title, go.fields.compresses,
  {
    sel: result.select.yes(result.fields.useCompresses.p5.field),
    srv: fields.compressesType
  }
)

// +++ ADD       p5dry (list)
result.fields.dry.p5 = tools.cfg.list(
  `p5${fields.dry}`,
  result.fields.dry.p1p2p3p4.config.title, go.fields.yesNo, {
    sel: result.select.yes(result.fields.antiseptic.p5[0].field),
    srv: fields.dry
  }
)

// +++ ADD       p5gloves (list)
result.fields.gloves.p5 = tools.cfg.list(
  `p5${fields.gloves}`,
  result.fields.gloves.b2.config.title, go.fields.yesNo, {
    sel: result.select.p5, srv: fields.gloves
  }
)

// +++ ADD       p5glovesType (list)
result.fields.glovesType.p5 = tools.cfg.list(
  `p5${fields.glovesType}`,
  result.fields.glovesType.b2.config.title,
  result.fields.glovesType.b2.config.values, {
    sel: result.select.yes(result.fields.gloves.p5.field),
    srv: fields.glovesType
  }
)

// +++ ADD       p5glovesPutOn (list)
result.fields.glovesPutOn.p5 = tools.cfg.list(
  `p5${fields.glovesPutOn}`,
  result.fields.glovesPutOn.p2p3.config.title,
  go.fields.p5glovesPutOn, {
    sel: result.select.yes(result.fields.gloves.p5.field),
    srv: fields.glovesPutOn
  }
)

//     UPDATE    handHygieneBeforePrepaOrInstall (list)handHygieneBeforePrepaOrInstall>selectList>0/0: different function names "oneTrue ((obsManagment === 3), (obsManagment === 5))" "oneTrue ((obsManagment === 3), (obsManagment === 8), (obsManagment === 5))}"
result.fields.handHygieneBeforePrepaOrInstall = {
  p3p5b2: result.build.handHygiene(
    fields.handHygiene, 'BeforePrepaOrInstall',
    `avant la préparation du matériel et/ou l'installation du patient`,
    result.select.p3p5b2,
    null,
    go.fields.handHygieneTypeSimple
  )
}

// +++ ADD       handHygieneBeforeP5Gloves (list)
// +++ ADD       handHygieneBeforeP5GlovesType (list)
// +++ ADD       handHygieneBeforeP5GlovesCompliant (list)
result.fields.handHygieneBeforeGloves.p5 = result.build.handHygiene(
  fields.secondaryHandHygiene, 'BeforeP5Gloves',
  `avant d'enfiler les gants`,
  tools.allTrue(
    result.select.yes(result.fields.gloves.p5.field),
    tools.inList(result.fields.glovesPutOn.p5.field, [2, 3, 4])
  ),
  null,
  go.fields.handHygieneTypeSimple
)

// +++ ADD       handHygieneBeforeP5InsertionNoGloves (list)
// +++ ADD       handHygieneBeforeP5InsertionNoGlovesType (list)
// +++ ADD       handHygieneBeforeP5InsertionNoGlovesCompliant (list)
result.fields.handHygieneBeforeInsertionNoGloves = {
  p5: result.build.handHygiene(
    fields.secondaryHandHygiene, 'BeforeP5InsertionNoGloves',
    `avant l'insertion`,
    result.select.no(result.fields.gloves.p5.field),
    null,
    go.fields.handHygieneTypeSimple
  )
}

// --- REMOVE    sheathJustBeforeInsertion (list)
delete result.fields.sheathJustBeforeInsertion

// --- REMOVE    p1p2rinsingAfterCatheterInsertion (list)
// --- REMOVE    p3rinsingAfterCatheterInsertion (list)
delete result.fields.rinsingAfterCatheterInsertion

// --- REMOVE    p1insertionGlovesKeptForRinsing (list)
// --- REMOVE    p3insertionGlovesKeptForRinsing (list)
delete result.fields.insertionGlovesKeptForRinsing

result.select.withRinsing = tools.oneTrue(
  result.select.yes(result.fields.rinsingBeforeManipulation.b1b2.field),
  result.select.yes(result.fields.rinsingAfterManipulation.b1b2.field),
  tools.equals(result.fields.manipType.b1.field, 5),
  tools.equals(result.fields.manipType.b2.field, 5)
)

//     UPDATE    syringeCapacity (list) syringeCapacity>selectList>0/0: different function names "allTrue (oneTrue ((obsManagment === 1), (obsManagment === 2), (obsManagment === 3), (obsManagment === 4), (obsManagment === 5)), oneTrue ((p1p2rinsingAfterCatheterInsertion === 1), (p3rinsingAfterCatheterInsertion === 1), (rinsingBeforeManipulation === 1), (rinsingAfterManipulation === 1), (b1manipType === 5), (b2manipType === 5)))" "allTrue (oneTrue ((obsManagment === 4), (obsManagment === 5)), oneTrue ((rinsingBeforeManipulation === 1), (rinsingAfterManipulation === 1), (b1manipType === 5), (b2manipType === 5)))}"
result.fields.syringeCapacity = {
  b1b2: tools.select(
    result.fields.syringeCapacity.p1p2p3b1b2,
    tools.allTrue(
      result.select.b1b2, result.select.withRinsing
    )
  )
}
result.rename(result.fields.syringeCapacityOther, 'p1p2p3b1b2', 'b1b2')

// +++ ADD       injectedRinsingVolume (list)
result.fields.injectedRinsingVolume = {
  b1b2: tools.cfg.list(
    fields.injectedRinsingVolume, `Volume injecté`,
    go.fields.injectedRinsingVolume, {
      sel: tools.allTrue(result.select.b1b2, result.select.withRinsing)
    }
  )
}

//     UPDATE    injectedRinsingSolution (list)injectedRinsingSolution>selectList>0/0: different function names "allTrue (oneTrue ((obsManagment === 1), (obsManagment === 2), (obsManagment === 3), (obsManagment === 4), (obsManagment === 5)), oneTrue ((p1p2rinsingAfterCatheterInsertion === 1), (p3rinsingAfterCatheterInsertion === 1), (rinsingBeforeManipulation === 1), (rinsingAfterManipulation === 1), (b1manipType === 5), (b2manipType === 5)))" "allTrue (oneTrue ((obsManagment === 4), (obsManagment === 5)), oneTrue ((rinsingBeforeManipulation === 1), (rinsingAfterManipulation === 1), (b1manipType === 5), (b2manipType === 5)))}"
result.fields.injectedRinsingSolution = {
  b1b2: tools.select(
    result.fields.injectedRinsingSolution.p1p2p3b1b2,
    tools.allTrue(result.select.b1b2, result.select.withRinsing)
  )
}
result.rename(result.fields.injectedRinsingSolutionOther, 'p1p2p3b1b2', 'b1b2')

//     UPDATE    readyPreFilledSyringe (list)readyPreFilledSyringe>selectList>0/0: different function names "allTrue (oneTrue ((obsManagment === 1), (obsManagment === 2), (obsManagment === 3), (obsManagment === 4), (obsManagment === 5)), oneTrue ((p1p2rinsingAfterCatheterInsertion === 1), (p3rinsingAfterCatheterInsertion === 1), (rinsingBeforeManipulation === 1), (rinsingAfterManipulation === 1), (b1manipType === 5), (b2manipType === 5)))" "allTrue (oneTrue ((obsManagment === 4), (obsManagment === 5)), oneTrue ((rinsingBeforeManipulation === 1), (rinsingAfterManipulation === 1), (b1manipType === 5), (b2manipType === 5)))}"
result.fields.readyPreFilledSyringe = {
  b1b2: tools.select(
    result.fields.readyPreFilledSyringe.p1p2p3b1b2,
    tools.allTrue(result.select.b1b2, result.select.withRinsing)
  )
}
result.rename(result.fields.singleDoseRinsingSolution, 'p1p2p3b1b2', 'b1b2')
result.rename(result.fields.syringePreparedJustBeforeRinsing, 'p1p2p3b1b2', 'b1b2')

//     UPDATE    rinsingBySuccessivePushes (list)rinsingBySuccessivePushes>selectList>0/0: different function names "allTrue (oneTrue ((obsManagment === 1), (obsManagment === 2), (obsManagment === 3), (obsManagment === 4), (obsManagment === 5)), oneTrue ((p1p2rinsingAfterCatheterInsertion === 1), (p3rinsingAfterCatheterInsertion === 1), (rinsingBeforeManipulation === 1), (rinsingAfterManipulation === 1), (b1manipType === 5), (b2manipType === 5)))" "allTrue (oneTrue ((obsManagment === 4), (obsManagment === 5)), oneTrue ((rinsingBeforeManipulation === 1), (rinsingAfterManipulation === 1), (b1manipType === 5), (b2manipType === 5)))}"
result.fields.rinsingBySuccessivePushes = {
  b1b2: tools.select(
    result.fields.rinsingBySuccessivePushes.p1p2p3b1b2,
    tools.allTrue(
      result.select.b1b2, result.select.withRinsing
    )
  )
}

//     UPDATE    rinsingSuccessivePushesCount (numeric)rinsingSuccessivePushesCount>selectList>0/0: different function names "allTrue (oneTrue ((obsManagment === 1), (obsManagment === 2), (obsManagment === 3), (obsManagment === 4), (obsManagment === 5)), oneTrue ((p1p2rinsingAfterCatheterInsertion === 1), (p3rinsingAfterCatheterInsertion === 1), (rinsingBeforeManipulation === 1), (rinsingAfterManipulation === 1), (b1manipType === 5), (b2manipType === 5)), (rinsingBySuccessivePushes === 1))" "allTrue (oneTrue ((obsManagment === 4), (obsManagment === 5)), oneTrue ((rinsingBeforeManipulation === 1), (rinsingAfterManipulation === 1), (b1manipType === 5), (b2manipType === 5)), (rinsingBySuccessivePushes === 1))}"
result.fields.rinsingSuccessivePushesCount = {
  b1b2: tools.select(
    result.fields.rinsingSuccessivePushesCount.p1p2p3b1b2,
    tools.allTrue(
      result.select.b1b2,
      result.select.withRinsing,
      result.select.yes(result.fields.rinsingBySuccessivePushes.b1b2.field)
    )
  )
}

//     UPDATE    syringeEliminatedImmediatelyAfterRinsing (list)syringeEliminatedImmediatelyAfterRinsing>selectList>0/0: different function names "allTrue (oneTrue ((obsManagment === 1), (obsManagment === 2), (obsManagment === 3), (obsManagment === 4), (obsManagment === 5)), oneTrue ((p1p2rinsingAfterCatheterInsertion === 1), (p3rinsingAfterCatheterInsertion === 1), (rinsingBeforeManipulation === 1), (rinsingAfterManipulation === 1), (b1manipType === 5), (b2manipType === 5)))" "allTrue (oneTrue ((obsManagment === 4), (obsManagment === 5)), oneTrue ((rinsingBeforeManipulation === 1), (rinsingAfterManipulation === 1), (b1manipType === 5), (b2manipType === 5)))}"
result.fields.syringeEliminatedImmediatelyAfterRinsing = {
  b1b2: tools.select(
    result.fields.syringeEliminatedImmediatelyAfterRinsing.p1p2p3b1b2,
    tools.allTrue(result.select.b1b2, result.select.withRinsing)
  )
}

//     UPDATE    solutionContainerEliminatedImmediatelyAfterRinsing (list)solutionContainerEliminatedImmediatelyAfterRinsing>selectList>0/0: different function names "allTrue (oneTrue ((obsManagment === 1), (obsManagment === 2), (obsManagment === 3), (obsManagment === 4), (obsManagment === 5)), oneTrue ((p1p2rinsingAfterCatheterInsertion === 1), (p3rinsingAfterCatheterInsertion === 1), (rinsingBeforeManipulation === 1), (rinsingAfterManipulation === 1), (b1manipType === 5), (b2manipType === 5)), (readyPreFilledSyringe === 2))" "allTrue (oneTrue ((obsManagment === 4), (obsManagment === 5)), oneTrue ((rinsingBeforeManipulation === 1), (rinsingAfterManipulation === 1), (b1manipType === 5), (b2manipType === 5)), (readyPreFilledSyringe === 2))}"
result.fields.solutionContainerEliminatedImmediatelyAfterRinsing = {
  b1b2: tools.select(
    result.fields.solutionContainerEliminatedImmediatelyAfterRinsing.p1p2p3b1b2,
    tools.allTrue(
      result.select.b1b2,
      result.select.withRinsing,
      result.select.no(result.fields.readyPreFilledSyringe.b1b2.field)
    )
  )
}

// +++ ADD       p5whyNotAlcool (list)
// +++ ADD       p5whyNotAlcoolDetail (text)
result.fields.whyNotAlcool.p5 = result.build.notAlcool(
  'p5', [1, 3, 4, 6, 9], result.select.p5, 'p5'
)

//     UPDATE    whyNotSGForPalpation (list)whyNotSGForPalpation>config>values: different sizes
result.fields.whyNotSGForPalpation.p2[0].config.values = go.fields.whyNotSterileGlovesForPalpation
result.fields.whyNotSGForPalpation.p2[0].contextualize = (function () {
  const select = result.select
  const ctx = function (sheet) {
    assert(select.p2(sheet, sheet), `Invalid context for field «${this.config.title}»`)
    const noGloves = select.no(result.fields.gloves.p2p3.field)(sheet, sheet)
    if (noGloves) {
      return {}
    }

    const withoutAnswer2 = clone(go.fields.whyNotSterileGlovesForPalpation)
    withoutAnswer2.splice(1, 1)
    return {
      values: withoutAnswer2
    }
  }

  Object.defineProperty(
    ctx, 'name', {
      value: `whyNotSGForPalpation.p2`
    }
  )
  return ctx
}
)()

// +++ ADD       whyNotSGForInsertion (list)
// +++ ADD       whyNotSGForInsertionDetail (text)
result.fields.whyNotSGForInsertion = {
  p5: result.build.why(
    '', fields.whyNotSGForInsertion,
    `Pourquoi l'opérateur n'a-t-il pas porté de gants stériles pour l'insertion ?`,
    tools.allTrue(
      result.select.p5,
      tools.oneTrue(
        result.select.no(result.fields.gloves.p5.field),
        tools.equals(result.fields.glovesType.p5.field, 1)
      )
    ),
    go.fields.whyNotGloves,
    4,
    (function () {
      const select = result.select
      const ctx = function (sheet) {
        assert(select.p5(sheet, sheet), `Invalid context for field «${this.config.title}»`)
        const noGloves = select.no(result.fields.gloves.p5.field)(sheet, sheet)
        if (noGloves) {
          return {}
        }

        const withoutAnswer2 = clone(go.fields.whyNotGloves)
        withoutAnswer2.splice(1, 1)
        return {
          values: withoutAnswer2
        }
      }

      Object.defineProperty(
        ctx, 'name', {
          value: `whyNotSGForInsertion.p5`
        }
      )
      return ctx
    })()
  )
}

//     UPDATE    whyNotP2HH (list)      whyNotP2HH>contextualize: different function body "function ctx(sheet) {Object(_sui_tools_assert____["default"])(select.p2(sheet), "Invalid context for field \xAB".concat(this.config.title, "\xBB")); var noGloves = select.no(_sui_data_sheets_edit_fields____["default"].handHygieneBeforePeriInsertion)(sheet); return {values: noGloves ? _gojs_go____["default"].fields.whyNotP2HH : _gojs_go____["default"].fields.whyNotHH};}" "function ctx(sheet) {Object(_sui_tools_assert____["default"])(select.p2(sheet), "Invalid context for field \xAB".concat(this.config.title, "\xBB")); var noGloves = select.no(_sui_data_sheets_edit_fields____["default"].handHygieneBeforePeriInsertion)(sheet); var glovesPutOnBeforeInsertion = select.equals(result.fields.glovesPutOn.p2p3.field, 3); return {values: noGloves || glovesPutOnBeforeInsertion ? _gojs_go____["default"].fields.whyNotP2HH : _gojs_go____["default"].fields.whyNotHH};}"
result.fields.whyNotHH.p2[0].contextualize = (function () {
  const select = result.select
  const ctx = function (sheet) {
    assert(select.p2(sheet, sheet), `Invalid context for field «${this.config.title}»`)
    const noGloves = select.no(fields.handHygieneBeforePeriInsertion)(sheet, sheet)
    const glovesPutOnBeforeInsertion = tools.equals(
      result.fields.glovesPutOn.p2p3.field, 3
    )(sheet, sheet)
    return {
      values: noGloves || glovesPutOnBeforeInsertion
        ? go.fields.whyNotP2HH : go.fields.whyNotHH
    }
  }
  Object.defineProperty(
    ctx, 'name', {
      value: `whyNotHH.p2`
    }
  )
  return ctx
})()

// --- REMOVE    whyNotHHCompliant (list)
// +++ ADD       whyNotHHCompliantPrerequisitesNotCompliant (list)
// +++ ADD       whyNotHHCompliantMissingStep (list)
// +++ ADD       whyNotHHCompliantNotLongEnough (list)
// +++ ADD       whyNotHHCompliantNotEnoughGel (list)
//     UPDATE    whyNotHHCompliantDetail (text)whyNotHHCompliantDetail>config>optional: different values (undefined / true)
//     UPDATE    whyNotHHCompliantDetail (text)whyNotHHCompliantDetail>config>title: different values (Préciser / Autre raison)
//     UPDATE    whyNotHHCompliantDetail (text)whyNotHHCompliantDetail>selectList>0/0: different function names "(whyNotHHCompliant === 5)" "allTrue ((obsManagment === 2), (handHygieneBeforePeriInsertionCompliant === 2), (handHygieneBeforePeriInsertionType === 1))}"
//     UPDATE    whyNotHHCompliantDetail (text)whyNotHHCompliantDetail>selectList>0/0: different function body "function result(d) {return d[f] === v;}" "function result(d, s) {return selectList(l, d, s);}"
result.fields.whyNotHHCompliant = (function () {
  function fieldList (prefix, selector) {
    const prerequisitesField = `${prefix}${fields.whyNotHHCompliantPrerequisitesNotCompliant}`
    const stepField = `${prefix}${fields.whyNotHHCompliantMissingStep}`
    const durationField = `${prefix}${fields.whyNotHHCompliantNotLongEnough}`
    const gelField = `${prefix}${fields.whyNotHHCompliantNotEnoughGel}`

    return [
      tools.cfg.list(
        prerequisitesField,
        `Pré-requis non conforme`, go.fields.yesNo, {
          sel: selector, srv: fields.whyNotHHCompliantPrerequisitesNotCompliant
        }
      ),
      tools.cfg.list(
        stepField,
        `Au moins une des sept étapes n'a pas été respectée`,
        go.fields.yesNo, {
          sel: selector, srv: fields.whyNotHHCompliantMissingStep
        }
      ),
      tools.cfg.list(
        durationField,
        `Durée du geste insuffisante`, go.fields.yesNo, {
          sel: selector, srv: fields.whyNotHHCompliantNotLongEnough
        }
      ),
      tools.cfg.list(
        gelField,
        `Quantité de produit insuffisante`, go.fields.yesNo, {
          sel: selector,
          srv: fields.whyNotHHCompliantNotEnoughGel
        }
      ),
      tools.cfg.text(
        `${prefix}${fields.whyNotHHCompliantDetail}`, 'Autre raison', {
          sel: tools.allTrue(
            selector,
            result.select.no(prerequisitesField),
            result.select.no(stepField),
            result.select.no(durationField),
            result.select.no(gelField)
          ),
          srv: fields.whyNotHHCompliantDetail
        }
      )
    ]
  }

  return {
    p2: fieldList(
      'p2',
      tools.allTrue(
        result.select.p2,
        tools.oneTrue(
          tools.allTrue(
            tools.equals(result.fields.handHygieneBeforePeriInsertion.p2p4[1].field, 1),
            result.select.no(result.fields.handHygieneBeforePeriInsertion.p2p4[2].field)
          ),
          tools.allTrue(
            tools.equals(result.fields.handHygieneBeforePreparation.p2[1].field, 1),
            result.select.no(result.fields.handHygieneBeforePreparation.p2[2].field),
            tools.equals2(result.fields.glovesPutOn.p2p3.field, 1, 2)
          )
        )
      )
    ),

    p5: fieldList(
      'p5',
      tools.allTrue(
        result.select.p5,
        tools.oneTrue(
          tools.allTrue(
            tools.equals(result.fields.handHygieneBeforeGloves.p5[1].field, 1),
            result.select.no(result.fields.handHygieneBeforeGloves.p5[2].field)
          ),
          tools.allTrue(
            tools.equals(result.fields.handHygieneBeforeInsertionNoGloves.p5[1].field, 1),
            result.select.no(result.fields.handHygieneBeforeInsertionNoGloves.p5[2].field)
          ),
          tools.allTrue(
            tools.equals(result.fields.handHygieneBeforePrepaOrInstall.p3p5b2[1].field, 1),
            result.select.no(result.fields.handHygieneBeforePrepaOrInstall.p3p5b2[2].field),
            tools.equals(result.fields.glovesPutOn.p5.field, 1)
          )
        )
      )
    )
  }
})()

// --- REMOVE    whyNotRinsingDoneAfterCatheterInsertion (list)
// --- REMOVE    whyNotRinsingDoneAfterCatheterInsertionDetail (text)
delete result.fields.whyNotRinsingDoneAfterCatheterInsertion

// +++ ADD       p5whyNotHHBeforeGloves (list)
// +++ ADD       p5whyNotHHBeforeGlovesDetail (text)
result.fields.whyNotHHBeforeGloves.p5 = result.build.why(
  'p5', fields.whyNotHHBeforeGloves,
  `Pourquoi l'hygiène des mains n'a-t-elle pas été réalisée avant d'enfiler les gants ?`,
  tools.allTrue(
    result.select.p5,
    tools.notNull(result.fields.glovesPutOn.p5.field),
    result.select.no(result.fields.handHygieneBeforeGloves.p5[0].field)
  ),
  go.fields.whyNotHH,
  4
)

//     UPDATE    b1whyNotHHM (list)     b1whyNotHHM>config>title: different values (Pourquoi l'HDM n'a-t-elle pas été réalisée avant la désinfection du site de branchement ? / Pourquoi l'HDM n'a-t-elle pas été réalisée juste avant le soin ?)
result.fields.whyNotHHM.b1[0].config.title = `Pourquoi l'HDM n'a-t-elle pas été réalisée juste avant le soin ?`

//     UPDATE    whyNotSterileGloves (list)whyNotSterileGloves>selectList>0/0: different function names "allTrue ((obsManagment === 5), (b2glovesType != null && b2glovesType !== 2))" "allTrue ((obsManagment === 5), oneTrue ((b2gloves === 2), (b2glovesType != null && b2glovesType !== 2)))}"
result.fields.whyNotSterileGloves.b2[0] = tools.select(
  result.fields.whyNotSterileGloves.b2[0],
  tools.allTrue(
    result.select.b2,
    tools.oneTrue(
      tools.equals(result.fields.gloves.b2.field, 2),
      tools.different(result.fields.glovesType.b2.field, 2)
    )
  )
)

//     UPDATE    b2whyNotHHM (list)     b2whyNotHHM>selectList>0/0: different function names "allTrue ((obsManagment === 5), oneTrue ((handHygieneBeforeB2Gloves === 2), (handHygieneBeforeB2ManipNoGloves === 2)))" "allTrue ((obsManagment === 5), oneTrue ((handHygieneBeforeB2ManipNoGloves === 2), (handHygieneBeforeB2Gloves === 2), allTrue (([object Object] === 1), (handHygieneBeforePrepaOrInstall === 2))))}"
result.fields.whyNotHHM.b2[0] = tools.select(
  result.fields.whyNotHHM.b2[0],
  tools.allTrue(
    result.select.b2,
    tools.oneTrue(
      result.select.no(result.fields.handHygieneBeforeManipNoGloves.b2[0].field),
      result.select.no(result.fields.handHygieneBeforeGloves.b2[0].field),
      tools.allTrue(
        tools.equals(result.fields.glovesPutOnManip.b2.field, 1),
        result.select.no(result.fields.handHygieneBeforePrepaOrInstall.p3p5b2[0].field)
      )
    )
  )
)

//     UPDATE    whyNotHHBeforeAntisepsis (list)whyNotHHBeforeAntisepsis>config>values: different sizes
result.fields.whyNotHHBeforeAntisepsis.r1[0].config.values = go.fields.whyNotHHBeforeAntisepsis
result.fields.whyNotHHBeforeAntisepsis.r1[0] = tools.select(
  result.fields.whyNotHHBeforeAntisepsis.r1[0],
  tools.allTrue(
    result.select.r1,
    tools.not(result.select.yes(result.fields.handHygieneBeforeAntisepsis.r1[0].field))
  )
)

//     UPDATE    whyNotSGForAntisepsis (list)whyNotSGForAntisepsis>config>title: different values (Pourquoi les gants ne sont-ils pas stériles pour la réfection du pansement ? / Pourquoi l'opérateur ne porte-t-il pas de gants stériles pour la réfection du pansement ?)
//     UPDATE    whyNotSGForAntisepsis (list)whyNotSGForAntisepsis>selectList>0/0: different function names "allTrue ((obsManagment === 7), (r1repairglovesType === 1))" "allTrue ((obsManagment === 7), oneTrue ((r1repairgloves === 2), (r1repairglovesType != null && r1repairglovesType !== 2)))}"
result.fields.whyNotSGForAntisepsis.r1 = result.build.why(
  '', fields.whyNotSGForAntisepsis,
  `Pourquoi l'opérateur ne porte-t-il pas de gants stériles pour la réfection du pansement ?`,
  tools.allTrue(
    result.select.r1,
    tools.oneTrue(
      tools.isNull(result.fields.repairGloves.r1.field),
      tools.equals(result.fields.repairGloves.r1.field, 2),
      tools.different(result.fields.repairGlovesType.r1.field, 2)
    )
  ),
  go.fields.whyNotSGForAntisepsis,
  5
)

//     UPDATE    whyNotRinsingDoneWhenManipulating (list)whyNotRinsingDoneWhenManipulating>config>values: different sizes
result.fields.whyNotRinsingDoneWhenManipulating.b1b2[0].config.values = go.fields.whyNotRinsingDone
result.fields.whyNotRinsingDoneWhenManipulating.b1b2[0] = tools.select(
  result.fields.whyNotRinsingDoneWhenManipulating.b1b2[0],
  tools.allTrue(
    tools.oneTrue(
      tools.allTrue(
        result.select.b1,
        tools.different(result.fields.manipType.b1.field, 6)
      ),
      tools.allTrue(
        result.select.b2,
        tools.different(result.fields.manipType.b2.field, 6)
      )
    ),
    tools.oneTrue(
      tools.allTrue(
        tools.oneTrue(
          tools.equals(result.fields.deviceUsage.b1b2.field, 2),
          tools.equals(result.fields.manipType.b2.field, 7)
        ),
        result.select.no(result.fields.rinsingBeforeManipulation.b1b2.field)
      ),
      result.select.no(result.fields.rinsingAfterManipulation.b1b2.field)
    )
  )
)

result.titles.patient.p5 = result.build.title(
  'LE PATIENT',
  result.fields.patientCleanOutfit.p1p2p3p4p5b2,
  false, result.select.p5
)

result.titles.insertionSite.p5 = result.build.title(
  `PRÉPARATION CUTANÉE DU SITE D'INSERTION (ANTISEPSIE)`,
  result.fields.insertionSiteCleanedByPatient.p5
)

result.titles.glovesAndHH = {
  p1p2p3p5b2: result.build.title(
    'PORT DES GANTS ET HYGIÈNE DES MAINS',
    result.fields.gloves.p1,
    false,
    result.select.p1p2p3p5b2
  )
}

result.titles.whyNotHHCompliant = {
  p2: result.build.title(
    `POURQUOI LA TECHNIQUE D'HYGIÈNE DES MAINS PAR FRICTION N'EST-ELLE PAS CONFORME ?`,
    result.fields.whyNotHHCompliant.p2[0],
    true, null,
    'observation-question'
  ),

  p5: result.build.title(
    `POURQUOI LA TECHNIQUE D'HYGIÈNE DES MAINS PAR FRICTION N'EST-ELLE PAS CONFORME ?`,
    result.fields.whyNotHHCompliant.p5[0],
    true, null,
    'observation-question'
  )
}

delete result.titles.rinsing.p1p2
delete result.titles.rinsing.p3
delete result.titles.probeHandling

result.sheet = {
  titles: [
    result.titles.audited.all,
    result.titles.patient.p1p2p3b2r1,
    result.titles.patient.p4,
    result.titles.patient.p5,
    result.titles.ultrasound.p1p2,
    result.titles.padRemoval.r1,
    result.titles.insertionSite.p1p2,
    result.titles.insertionSite.p4,
    result.titles.manipulation.b1b2,
    result.titles.changePad.r1,
    result.titles.insertionSite.p3,
    result.titles.insertionSite.p5,
    result.titles.glovesAndHH.p1p2p3p5b2,
    result.titles.insertion.p4,
    result.titles.newPad.r1,
    result.titles.insertionWithUltrasound.p1,
    result.titles.rinsing.b1b2,
    result.titles.interview.all,
    result.titles.whyNotHHCompliant.p2,
    result.titles.whyNotHHCompliant.p5
  ],

  fields: [
    result.fields.obsManagment.all,
    ...tools.addSelect(result.select.obs, [
      patient.sheetNumber.v2,
      result.fields.obsDate.all
    ]),
    result.fields.isEhpad.p4,
    ...tools.addSelect(result.select.obs, [
      tools.opts(patient.unitType.v2.rw, { sp: 'unitType_v2' }),
      patient.uf
    ]),

    result.fields.place.p1,
    result.fields.otherPlace.p1,

    result.fields.fistula.p5,
    result.fields.buttonHole.p5,

    result.fields.catheterType.p1,
    result.fields.catheterType.p2,
    result.fields.catheterType.p4,
    result.fields.catheterType.p5,
    result.fields.catheterType.b1,
    result.fields.catheterType.b2,
    result.fields.catheterType.r1,
    result.fields.otherCatheterType.p1,
    result.fields.otherCatheterType.b2,
    result.fields.otherCatheterType.r1,

    result.fields.deviceUsage.b1b2,
    result.fields.withHelp.b2,
    result.fields.insertionSite.p1,
    result.fields.insertionSite.r1,
    result.fields.insertionSiteDetail.p1r1,

    result.fields.manipType.b1,
    result.fields.manipType.b2,
    result.fields.otherManipType.b1b2,
    result.fields.isolatedRinsingReason.b1b2,
    result.fields.isolatedRinsingReasonDetail.b1b2,
    result.fields.injectedProduct.b1b2,
    result.fields.injectedProductDetail.b1b2,

    result.fields.audited.p1,
    result.fields.audited.p2b1b2,
    result.fields.audited.p3p4r1,
    result.fields.audited.p5,
    result.fields.auditedDetail.p3p4r1,
    result.fields.auditedDetail.p1,
    result.fields.student.all,
    result.fields.auditedCleanOutfit.p2p3p4p5b1b2,
    result.fields.auditedCleanOutfitOrProt.r1,
    result.fields.sterileGown.p1,
    result.fields.sterileGown.r1,
    result.fields.auditedOvercoat.p5,
    result.fields.auditedCap.p1p3r1,
    result.fields.compliantAuditedCap.p1p3r1,
    result.fields.auditedMask.p1p3p5b2r1,
    result.fields.compliantAuditedMask.p1p3p5b2,
    result.fields.auditedCap.b2,
    result.fields.compliantAuditedCap.b2,
    result.fields.auditedEyeProtection.p5,
    result.fields.isAdult.p1p2p3r1,
    result.fields.childAge.p1p2p3r1,
    result.fields.patientCleanOutfit.p1p2p3p4p5b2,
    result.fields.patientMask.p1p3b2r1,
    result.fields.compliantPatientMask.p1p3b2r1,
    result.fields.patientSterileField.p1r1,
    result.fields.patientOtherSide.p3b2r1,
    result.fields.patientCap.p1,
    result.fields.compliantPatientCap.p1,
    result.fields.patientHeadSterileField.p1,
    result.fields.strippingSufficient.r1,
    result.fields.bmi.r1,

    result.fields.withUltrasound.p1p2,
    ...result.fields.ultrasoundWipingBeforeCare.p1p2,
    result.fields.usAuditedSearch.p1p2,
    result.fields.searchGelUsed.p1p2,
    result.fields.vialOpeningDateWritten.p1p2,
    result.fields.vialOpenedSince.p1p2,
    result.fields.searchUltrasoundSheath.p1p2,
    result.fields.sheathRemoval.p1p2,

    result.fields.scheduledDressingRepair.r1,
    result.fields.soiledDressing.r1,
    result.fields.dressingPeelsOff.r1,
    ...result.fields.handHygieneBeforeEquipmentPreparation.r1,
    result.fields.sterilePreparation.r1,
    result.fields.removeDressingByStretching.r1,
    result.fields.signsOfSkinIrritation.r1,

    result.fields.removalGloves.r1,
    result.fields.removalGlovesType.r1,
    result.fields.glovesRemoval.r1,

    ...result.fields.handHygieneBeforeAntisepsis.p4,
    ...result.fields.handHygieneBeforeDisinfection.b1,

    result.fields.hasStabilizer.r1,
    result.fields.changeStabilizer.r1,
    result.fields.changeStabilizerReason.r1,
    ...result.fields.handHygieneBeforeStabilizer.r1,

    result.fields.stabilizerGloves.r1,
    result.fields.stabilizerGlovesType.r1,
    result.fields.secondaryGlovesRemoval.r1,

    ...result.fields.handHygieneBeforeAntisepsis.r1,
    result.fields.repairGloves.r1,
    result.fields.repairGlovesType.r1,

    result.fields.dirtySkin.p1p2p3p4,
    result.fields.insertionSiteCleanedByPatient.p5,
    result.fields.insertionSiteCleaned.p1p2p3p4r1,
    result.fields.insertionSiteCleaned.p5,

    result.fields.soap.p1p2p3p4r1,
    result.fields.soap.p5,
    result.fields.soapOther.p1p2p3p4r1,
    result.fields.soapOther.p5,
    result.fields.rinsing.p1p2p3r1,
    result.fields.dryingWithSterileCompresses.p1p2p3r1,
    result.fields.rinsingProduct.p5,
    result.fields.dryingEquipment.p5,

    ...result.fields.antiseptic.p1p2p3p4,
    ...result.fields.antiseptic.r1,
    ...result.fields.antiseptic.p5,

    result.fields.useCompresses.r1,
    result.fields.useCompresses.p1p2p3p4,
    result.fields.useCompresses.b1b2,
    result.fields.useCompresses.p5,

    result.fields.compressesType.r1,
    result.fields.compressesType.p1p2p3p4,
    result.fields.compressesType.b1b2,
    result.fields.compressesType.p5,

    ...result.fields.antiseptic.b1,
    ...result.fields.antiseptic.b2,

    result.fields.valve.b1b2,
    ...result.fields.valveAntiseptic.b1b2,
    result.fields.antisepticPassages.p4,

    result.fields.dry.p1p2p3p4,
    result.fields.dry.r1,
    result.fields.dry.p5,
    result.fields.thirdGlovesRemoval.r1,
    result.fields.preFencedSterileField.p3,

    result.fields.glovesNecessary.b1,
    result.fields.gloves.p1,
    result.fields.gloves.p2p3,
    result.fields.gloves.b1,
    result.fields.gloves.b2,
    result.fields.gloves.p5,

    result.fields.glovesType.p1,
    result.fields.glovesType.p2p3b1,
    result.fields.glovesType.b2,
    result.fields.glovesType.p5,

    result.fields.glovesPutOn.p1,
    result.fields.glovesPutOn.p2p3,
    result.fields.glovesPutOn.p5,
    result.fields.glovesPutOnManip.b2,
    result.fields.palpation.p2,

    ...result.fields.handHygieneBeforeInsertionGloves.p1,
    ...result.fields.handHygieneBeforePreparation.p2,
    ...result.fields.handHygieneBeforePeriInsertion.p2p4,
    ...result.fields.handHygieneBeforePrepaOrInstall.p3p5b2,
    ...result.fields.handHygieneBeforeGloves.p3,
    ...result.fields.handHygieneBeforeGloves.b2,
    ...result.fields.handHygieneBeforeGloves.p5,
    ...result.fields.handHygieneBeforePuncture.p3,
    ...result.fields.handHygieneBeforeManipNoGloves.b2,
    ...result.fields.handHygieneBeforeInsertionNoGloves.p5,

    result.fields.gloves.p4,
    result.fields.glovesType.p4,
    result.fields.holdTissue.p4,

    ...result.fields.handHygieneBeforeImplementation.r1,

    result.fields.implementationGloves.r1,
    result.fields.implementationGlovesType.r1,

    result.fields.insertionUltrasoundSheath.p1p2,
    result.fields.probeCovered.p1p2,
    result.fields.insertionGelUsed.p1p2,
    result.fields.gelApplied.p1p2,
    result.fields.probeNeedleContact.p1p2,
    result.fields.auditedTouchProbe.p1p2,
    result.fields.probeTouchedWith.p1p2,
    result.fields.probeTouchedWithDetail.p1p2,

    result.fields.glovesRemoval.p1,
    result.fields.glovesRemoval.p2,

    result.fields.rinsingBeforeManipulation.b1b2,
    result.fields.rinsingAfterManipulation.b1b2,
    result.fields.syringeCapacity.b1b2,
    result.fields.syringeCapacityOther.b1b2,
    result.fields.injectedRinsingVolume.b1b2,
    result.fields.injectedRinsingSolution.b1b2,
    result.fields.injectedRinsingSolutionOther.b1b2,
    result.fields.readyPreFilledSyringe.b1b2,
    result.fields.singleDoseRinsingSolution.b1b2,
    result.fields.syringePreparedJustBeforeRinsing.b1b2,
    result.fields.rinsingBySuccessivePushes.b1b2,
    result.fields.rinsingSuccessivePushesCount.b1b2,
    result.fields.syringeEliminatedImmediatelyAfterRinsing.b1b2,
    result.fields.solutionContainerEliminatedImmediatelyAfterRinsing.b1b2,

    result.fields.nakedEyeSheathInspection.p1p2,
    result.fields.tearedSheath.p1p2,
    result.fields.probeInspection.p1p2,
    result.fields.dirtyProbe.p1p2,
    result.fields.probeCleaned.p1p2,
    result.fields.probeCleaningMethod.p1p2,
    result.fields.probeCleaningMethodDetail.p1p2,
    ...result.fields.probeCleaningProduct.p1p2,

    ...result.fields.whySheathNotRemovedAfterSearch.p1,
    ...result.fields.whyNotChlAlc2Percent.p1,
    ...result.fields.whyNotSurgicalHandrubbing.p1,
    ...result.fields.whyNotRemoveGlovesAfterTouch.p1,
    ...result.fields.whyNCAuditedOutfit.p3,
    ...result.fields.whyNotAuditedMask.b2,
    ...result.fields.whyNCPatientOutfit.p3,
    ...result.fields.whyNotAlcool.p2p3p4,
    ...result.fields.whyNotAlcool.p5,
    ...result.fields.whyNotSGForPalpation.p2,
    ...result.fields.whyNotSGForInsertion.p5,
    ...result.fields.whyNotHH.p2,
    ...result.fields.whyNotHH.p4,

    ...result.fields.whyNotHHCompliant.p2,
    ...result.fields.whyNotHHBeforeGloves.p3,
    ...result.fields.whyNotHHBeforeGloves.p5,
    ...result.fields.whyNotHHCompliant.p5,
    ...result.fields.whyNotGloves.p4,
    ...result.fields.whyNotHHM.b1,
    ...result.fields.whyNotCompresses.b1,
    ...result.fields.whyNotSterileCompresses.b1,
    ...result.fields.whyNotDisinfectValve.b1b2,
    ...result.fields.whyNotSterileGloves.b2,
    ...result.fields.whyNotHHM.b2,
    ...result.fields.whyNotGROnStabilizerChange.r1,
    ...result.fields.whyNotHHBeforeAntisepsis.r1,
    ...result.fields.whyNotSGForAntisepsis.r1,
    ...result.fields.whyNotRinsingDoneWhenManipulating.b1b2
  ],

  buildNotes: function (resultNotes, sheet) {
    checkAge(
      resultNotes, sheet, {
        unitType: patient.unitType.v2.rw.field,
        isAdult: result.fields.isAdult.p1p2p3r1.field,
        childAge: result.fields.childAge.p1p2p3r1.field
      }
    )

    checkDate(
      resultNotes, sheet, '2026', {
        obsDate: result.fields.obsDate.all
      }
    )

    checkB2Gloves(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        whyNotHHM: result.fields.whyNotHHM.b2[0].field,
        gloves: result.fields.gloves.b2.field
      }
    )

    checkDeviceInsertionSite(
      resultNotes, sheet, 1, {
        obsManagment: result.fields.obsManagment.all.field,
        catheterType: result.fields.catheterType.p1.field,
        insertionSite: result.fields.insertionSite.p1.field
      },
      'p1'
    )

    checkDeviceInsertionSite(
      resultNotes, sheet, 7, {
        obsManagment: result.fields.obsManagment.all.field,
        catheterType: result.fields.catheterType.r1.field,
        insertionSite: result.fields.insertionSite.r1.field
      },
      'r1'
    )

    checkProbeTouchedWithGloves(
      resultNotes, sheet, 1, {
        obsManagment: result.fields.obsManagment.all.field,
        probeTouchedWith: result.fields.probeTouchedWith.p1p2.field
      },
      result.fields.glovesRemoval.p1
    )

    checkProbeTouchedWithGloves(
      resultNotes, sheet, 2, {
        obsManagment: result.fields.obsManagment.all.field,
        probeTouchedWith: result.fields.probeTouchedWith.p1p2.field
      },
      result.fields.glovesRemoval.p2
    )

    checkBMI(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field
      }
    )

    checkP1Chlorex(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        catheterType: result.fields.catheterType.p1.field,
        whyNotChlAlc2Percent: result.fields.whyNotChlAlc2Percent.p1[0].field
      }
    )

    checkHeadFaceSterileField(
      resultNotes, sheet, {
        patientHeadSterileField: result.fields.patientHeadSterileField.p1.field,
        patientSterileField: result.fields.patientSterileField.p1r1.field
      }
    )

    checkEhpadService(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        isEhpad: result.fields.isEhpad.p4.field,
        unitType: patient.unitType.v2.rw.field
      }
    )

    checkIsolatedRinsingOfContinuousCatheter(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        isolatedRinsingReason: result.fields.isolatedRinsingReason.b1b2.field,
        deviceUsage: result.fields.deviceUsage.b1b2.field
      }
    )

    checkGelAppliedWithoutSheath(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        gelApplied: result.fields.gelApplied.p1p2.field,
        insertionUltrasoundSheath: result.fields.insertionUltrasoundSheath.p1p2.field
      }
    )

    checkVialOpenedSince(
      resultNotes, sheet, {
        vialOpenedSince: result.fields.vialOpenedSince.p1p2.field,
        vialOpeningDateWritten: result.fields.vialOpeningDateWritten.p1p2.field

      }
    )

    checkGelUsed(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        searchGelUsed: result.fields.searchGelUsed.p1p2.field,
        insertionGelUsed: result.fields.insertionGelUsed.p1p2.field
      }
    )

    checkRinsingSuccessivePushesCount(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field
      }
    )

    checkNeedleWithdrawalManipType(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        manipType: result.fields.manipType.b2.field,
        catheterType: result.fields.catheterType.b2.field
      }
    )

    checkP5IsAdult(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        unitType: patient.unitType.v2.rw.field
      }
    )

    checkInjectedRinsingVolume(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        injectedRinsingVolume: result.fields.injectedRinsingVolume.b1b2.field,
        syringeCapacity: result.fields.syringeCapacity.b1b2.field,
        syringeCapacityOther: result.fields.syringeCapacityOther.b1b2.field
      }
    )

    checkAntiseptic(
      resultNotes, sheet, 4, {
        obsManagment: result.fields.obsManagment.all.field,
        antiseptic: result.fields.antiseptic.b1[1].field,
        valveAntiseptic: result.fields.valveAntiseptic.b1b2[2].field
      }
    )
    checkAntiseptic(
      resultNotes, sheet, 5, {
        obsManagment: result.fields.obsManagment.all.field,
        antiseptic: result.fields.antiseptic.b2[1].field,
        valveAntiseptic: result.fields.valveAntiseptic.b1b2[2].field
      }
    )
    checkFreeFlowWithDiscontinuousUsage(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        whyNotRinsingDoneWhenManipulating: result.fields.whyNotRinsingDoneWhenManipulating.b1b2[0].field,
        deviceUsage: result.fields.deviceUsage.b1b2.field
      }
    )

    return resultNotes
  }
}

result.assertAllFieldsAreUsed('2026')

export default ice.freeze(result, 10)
